import enCA from 'date-fns/locale/en-CA';
import enUS from 'date-fns/locale/en-US';
import frCA from 'date-fns/locale/fr-CA';

import {
  CURRENCY_CODE_FORMAT,
  LANGUAGES,
  LOCALES,
  LocaleData,
  MONEY_FORMAT,
} from 'state/intl/types';
import { Region } from 'utils/environment/types';

export const LOCALE_DATA = {
  [LOCALES.en_us]: {
    code: LOCALES.en_us,
    region: Region.US,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_us,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_us,
    dateFormat: enUS,
  },
  [LOCALES.en_ca]: {
    code: LOCALES.en_ca,
    region: Region.CA,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_ca,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_ca,
    dateFormat: enCA,
  },
  [LOCALES.fr_ca]: {
    code: LOCALES.fr_ca,
    region: Region.CA,
    language: LANGUAGES.fr,
    moneyFormat: MONEY_FORMAT.fr_ca,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.fr_ca,
    dateFormat: frCA,
  },
};

export const SORTED_PROD_LOCALES = [
  LOCALE_DATA[LOCALES.en_us] as LocaleData,
  LOCALE_DATA[LOCALES.en_ca] as LocaleData,
  LOCALE_DATA[LOCALES.fr_ca] as LocaleData,
];
